module.exports = __webpack_public_path__ + "static/media/ndi-poster.a4bcfcf5.pdf";